import { IBaoCaoRequest } from "../../model/request/bao-cao/IBaoCaoRequest";
import { apiClient } from "../apiClient";
export const BAO_CAO_ENDPOINT = "bao-cao";

export const baoCaoApi = {
  RenderHtml: (request: IBaoCaoRequest) =>
    apiClient.post(`${BAO_CAO_ENDPOINT}/render-html`, request),

  ExportExcel: (request: IBaoCaoRequest) =>
    apiClient.post(`${BAO_CAO_ENDPOINT}/export-excel`, request),
};
